export const loadTasks = ({ ...params }) => ({
  type: "LOAD_TASKS",
  payload: {
    request: {
      method: "GET",
      url: "/tasks",
      ...params,
      showLoading: false,
    },
  },
});

export var loadTaskLogs = function(id) {
  return {
    type: 'LOAD_TASK_LOGS',
    payload: {
      request: {
        method: 'get',
        url: '/task/' + id + '/logs',
        showLoading: false,
      },
    },
  };
};
